<template>
  <Card class="shopCard" @click="toDetail(data)" :thumb="tyreImg">
    <template #title>
      <h2>{{ data?.name || '轮胎商品' }}</h2>
      <p class="remark">{{ data?.remark || '' }}</p>
    </template>
  </Card>
</template>
<script>
import { reactive, toRefs } from 'vue'
import tyreImg from '@/assets/images/tyre.png'
import Card from '@/components/shop/Card'

export default {
  props: ['data'],
  emits: ['link'],
  components: {
    Card
  },
  setup(props, { emit }) {
    let { data } = toRefs(props)
    const state = reactive({
      data: data.value,
      tyreImg
    })
    let toDetail = data => {
      emit('link', data)
    }
    return {
      ...toRefs(state),
      toDetail
    }
  }
}
</script>
<style lang="scss" scoped>
h2 {
  font-size: 14px !important;
  color: #333333;
  font-weight: bold;
  margin-bottom: 15px;
}
.remark {
  font-weight: 100;
}
</style>
